import React from "react";

import { Box, Group, Drawer, Button, SegmentedControl, useMantineTheme, Text, Paper, ActionIcon } from '@mantine/core';
import { IconChevronRight, IconX, IconArrowLeft } from '@tabler/icons-react';

import { utils } from "../../utils/globalVariables";

import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import StockCategorySelectorDrawer from "../../components/utilities/StockCategorySelectorDrawer";
import StockCategorySubSelectorDrawer from "../../components/utilities/StockCategorySubSelectorDrawer";
import SupplierSelectorDrawer from "../../components/utilities/SupplierSelectorDrawer";
import ActionIconComponent from "../../components/general/ActionIconComponent";
import PickerDate from "../../components/general/PickerDate";

const StockItemFilter = ({
    stateShow,
    fnShow,
    stateDefaultFilter,
    stateFilter,
    fnFilter
}) => {

    const theme = useMantineTheme();

    const [data, setData] = React.useState({
        filterStockCategory: stateFilter.stockCategory,
        filterStockCategorySub: stateFilter.stockCategorySub,
        filterStockSupplier: stateFilter.stockSupplier,

        filterStockTanggalBeliDari: stateFilter.stockTanggalBeliDari,
        filterStockTanggalBeliSampai: stateFilter.stockTanggalBeliSampai,

        filterStockTanda: stateFilter.stockTanda,
        filterStockGaransiType: stateFilter.stockGaransiType,

        filterStockIsActive: stateFilter.stockIsActive,
    });

    const handleFilter = () => {
        fnFilter(
            data.filterStockCategory.id,
            data.filterStockCategorySub.id,
            data.filterStockSupplier.id,
            data.filterStockIsActive,

            data.filterStockTanggalBeliDari,
            data.filterStockTanggalBeliSampai,

            data.filterStockTanda,
            data.filterStockGaransiType,
        )
    }

    const handleReset = () => {
        setData(d => ({
            ...d,
            filterStockCategory: stateDefaultFilter.stockCategory,
            filterStockCategorySub: stateDefaultFilter.stockCategorySub,
            filterStockSupplier: stateDefaultFilter.stockSupplier,
            filterStockIsActive: stateDefaultFilter.stockIsActive,

            filterStockTanggalBeliDari: stateDefaultFilter.stockTanggalBeliDari,
            filterStockTanggalBeliSampai: stateDefaultFilter.stockTanggalBeliSampai,

            filterStockTanda: stateDefaultFilter.stockTanda,
            filterStockGaransiType: stateDefaultFilter.stockGaransiType,
        }))
    }

    React.useEffect(() => {
        setData(d => ({
            ...d,
            filterStockCategorySub: stateDefaultFilter.stockCategorySub,
        }))
    }, [data.filterStockCategory.id, stateDefaultFilter.stockCategorySub])

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Filter Stok Item</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md' sx={{ minHeight: '500px' }}>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel='Kategori'
                            stateWithAsterisk={false}
                        >
                            <Paper
                                sx={(tema) => ({
                                    backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[6],
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                                    cursor: 'pointer',
                                })}

                                onClick={() => {
                                    setData(d => ({
                                        ...d,
                                        filterStockCategory: {
                                            ...d.filterStockCategory,
                                            show: true
                                        }
                                    }));
                                }}
                            >
                                {data.filterStockCategory.id === utils.flagAll &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Text size='sm'>Semua Kategori</Text>
                                        <IconChevronRight size="1rem" />
                                    </Group>
                                }

                                {data.filterStockCategory.id && (data.filterStockCategory.id !== utils.flagAll) &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Group noWrap>
                                            <Text size='sm'>
                                                <Text>
                                                    {data.filterStockCategory.name}
                                                </Text>

                                                <Text size='xs'>
                                                    {data.filterStockCategory.isActive === '1' ? 'Aktif' : 'Non Aktif'}
                                                </Text>
                                            </Text>
                                        </Group>

                                        <ActionIconComponent
                                            stateVariant='light'
                                            stateRadius='xl'
                                            stateTitle='Hapus'
                                            stateSize='lg'
                                            fnOnClick={(e) => {
                                                e.stopPropagation();

                                                setData(d => ({
                                                    ...d,
                                                    filterStockCategory: stateDefaultFilter.stockCategory
                                                }))
                                            }}

                                            StateIcon={IconX}
                                            stateIconSize='1.125rem'
                                            stateIconStrokeWidth={1.25}
                                            stateIconStyle={{
                                                color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                                            }}
                                        />
                                    </Group>
                                }
                            </Paper>
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel='Sub Kategori'
                            stateWithAsterisk={false}
                            stateError=''
                            stateDescription=''
                        >
                            <Paper
                                sx={(tema) => ({
                                    backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[6],
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                                    cursor: 'pointer',
                                })}

                                onClick={() => {
                                    setData(d => ({
                                        ...d,
                                        filterStockCategorySub: {
                                            ...d.filterStockCategorySub,
                                            show: true
                                        }
                                    }));
                                }}
                            >
                                {data.filterStockCategorySub.id === utils.flagAll &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Text size='sm'>Semua Sub Kategori</Text>
                                        <IconChevronRight size="1rem" />
                                    </Group>
                                }

                                {data.filterStockCategorySub.id && (data.filterStockCategorySub.id !== utils.flagAll) &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Group noWrap>
                                            <Text size='sm'>
                                                <Text>
                                                    {data.filterStockCategorySub.name}
                                                </Text>

                                                <Text size='xs'>
                                                    Kategori {data.filterStockCategorySub.categoryName}
                                                </Text>

                                                <Text size='xs'>
                                                    Status Sub Kategori {data.filterStockCategorySub.isActive === '1' ? 'Aktif' : 'Non Aktif'}
                                                </Text>
                                            </Text>
                                        </Group>

                                        <ActionIconComponent
                                            stateVariant='light'
                                            stateRadius='xl'
                                            stateTitle='Hapus'
                                            stateSize='lg'
                                            fnOnClick={(e) => {
                                                e.stopPropagation();

                                                setData(d => ({
                                                    ...d,
                                                    filterStockCategorySub: stateDefaultFilter.stockCategorySub
                                                }))
                                            }}

                                            StateIcon={IconX}
                                            stateIconSize='1.125rem'
                                            stateIconStrokeWidth={1.25}
                                            stateIconStyle={{
                                                color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                                            }}
                                        />
                                    </Group>
                                }
                            </Paper>
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel='Supplier'
                            stateWithAsterisk={false}
                        >
                            <Paper
                                sx={(tema) => ({
                                    backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[6],
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                                    cursor: 'pointer',
                                })}

                                onClick={() => {
                                    setData(d => ({
                                        ...d,
                                        filterStockSupplier: {
                                            ...d.filterStockSupplier,
                                            show: true
                                        }
                                    }));
                                }}
                            >
                                {data.filterStockSupplier.id === utils.flagAll &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Text size='sm'>Semua Supplier</Text>
                                        <IconChevronRight size="1rem" />
                                    </Group>
                                }

                                {data.filterStockSupplier.id && (data.filterStockSupplier.id !== utils.flagAll) &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Group noWrap>
                                            <Text size='sm'>
                                                <Text>
                                                    {data.filterStockSupplier.name}
                                                </Text>

                                                <Text size='xs'>
                                                    {data.filterStockSupplier.address ? data.filterStockSupplier.address : ' - '}
                                                </Text>

                                                <Text size='xs'>
                                                    {data.filterStockSupplier.contact ? data.filterStockSupplier.contact : ' - '}
                                                </Text>

                                                <Text size='xs'>
                                                    {data.filterStockSupplier.isActive === '1' ? 'Aktif' : 'Non Aktif'}
                                                </Text>
                                            </Text>
                                        </Group>

                                        <ActionIconComponent
                                            stateVariant='light'
                                            stateRadius='xl'
                                            stateTitle='Hapus'
                                            stateSize='lg'
                                            fnOnClick={(e) => {
                                                e.stopPropagation();

                                                setData(d => ({
                                                    ...d,
                                                    filterStockSupplier: stateDefaultFilter.stockCategory
                                                }))
                                            }}

                                            StateIcon={IconX}
                                            stateIconSize='1.125rem'
                                            stateIconStrokeWidth={1.25}
                                            stateIconStyle={{
                                                color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                                            }}
                                        />
                                    </Group>
                                }
                            </Paper>
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel='Tanggal Pembelian'
                            stateWithAsterisk={false}
                            stateError=''
                            stateDescription=''
                        >
                            <Group spacing='xs'>
                                <PickerDate
                                    stateMinDate={null}
                                    stateDate={data.filterStockTanggalBeliDari}

                                    fnSetDate={(val) => setData(d => ({
                                        ...d,
                                        filterStockTanggalBeliDari: val
                                    }))}

                                    stateSX={{
                                        flex: 1,
                                    }}

                                    stateFormat="DD MMM YYYY"
                                    stateClearable={true}
                                    stateLabel=''
                                    statePlaceHolder={data.filterStockTanggalBeliDari === null ? 'Semua' : 'Tanggal Pembelian'}
                                    stateWithAsterisk={false}
                                    stateDescription=''
                                    stateError=''
                                />

                                <Text size='sm'>s/d</Text>

                                <PickerDate
                                    stateMinDate={data.filterStockTanggalBeliDari}
                                    stateDate={data.filterStockTanggalBeliSampai}

                                    fnSetDate={(val) => setData(d => ({
                                        ...d,
                                        filterStockTanggalBeliSampai: val
                                    }))}

                                    stateSX={{
                                        flex: 1,
                                    }}

                                    stateFormat="DD MMM YYYY"
                                    stateClearable={true}
                                    stateLabel=''
                                    statePlaceHolder={data.filterStockTanggalBeliSampai === null ? 'Semua' : 'Tanggal Pembelian'}
                                    stateWithAsterisk={false}
                                    stateDescription=''
                                    stateError=''
                                />
                            </Group>
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel="Garansi"
                            stateWithAsterisk={false}
                            stateError=''
                            stateDescription=''
                        >
                            <SegmentedControl
                                fullWidth
                                value={data.filterStockGaransiType}
                                onChange={(val) => setData(d => ({ ...d, filterStockGaransiType: val }))}
                                data={[
                                    { label: 'Semua', value: utils.flagAll },
                                    ...Object.values(utils.masaGaransi).map(key => ({ value: key.value, label: key.caption }))
                                ]}
                            />
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel="Tanda"
                            stateWithAsterisk={false}
                            stateError=''
                            stateDescription=''
                        >
                            <SegmentedControl
                                fullWidth
                                value={data.filterStockTanda}
                                onChange={(val) => setData(d => ({ ...d, filterStockTanda: val }))}
                                data={[
                                    { label: 'Semua', value: utils.flagAll },
                                    { label: utils.stockItemStatus.new.caption, value: utils.stockItemStatus.new.value },
                                    { label: utils.stockItemStatus.claimed.caption, value: utils.stockItemStatus.claimed.caption },
                                    { label: utils.stockItemStatus.tagged.caption, value: utils.stockItemStatus.tagged.caption },
                                ]}
                            />
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel="Status Stok"
                            stateWithAsterisk={false}
                            stateError=''
                            stateDescription=''
                        >
                            <SegmentedControl
                                fullWidth
                                value={data.filterStockIsActive}
                                onChange={(val) => setData(d => ({ ...d, filterStockIsActive: val }))}
                                data={[
                                    { label: 'Semua', value: utils.flagAll },
                                    { label: 'Aktif', value: '1' },
                                    { label: 'Non Aktif', value: '0' },
                                ]}
                            />
                        </InputWrapperCustom>
                    </Box>

                    <Group position="apart" noWrap spacing='xs' my='xl'>
                        <Button
                            fullWidth
                            variant="default"
                            color='gray'
                            onClick={handleReset}
                        >
                            Reset
                        </Button>

                        <Button
                            fullWidth
                            color='teal'
                            onClick={handleFilter}
                        >
                            Filter
                        </Button>
                    </Group>
                </Box>
            </Drawer>

            <StockCategorySelectorDrawer
                stateShow={data.filterStockCategory.show}

                fnShow={() => setData(d => ({
                    ...d,
                    filterStockCategory: {
                        ...d.filterStockCategory,
                        show: false
                    }
                }))}

                fnOnSelect={(id, name, isActive) => setData(d => ({
                    ...d,
                    filterStockCategory: {
                        ...d.filterStockCategory,
                        id: id,
                        name: name,
                        isActive: isActive,
                        show: false,
                    }
                }))}
            />

            <StockCategorySubSelectorDrawer
                stateShow={data.filterStockCategorySub.show}

                fnShow={() => setData(d => ({
                    ...d,
                    filterStockCategorySub: {
                        ...d.filterStockCategorySub,
                        show: false
                    }
                }))}

                stateData={{
                    categoryId: data.filterStockCategory.id,
                    categoryIsActive: '1'
                }}

                fnOnSelect={(object) => setData(d => ({
                    ...d,
                    filterStockCategorySub: {
                        ...d.filterStockCategorySub,
                        id: object.stockCategorySubId,
                        name: object.stockCategorySubName,
                        isActive: object.stockCategorySubIsActive,
                        categoryId: object.stockCategoryId,
                        categoryName: object.stockCategoryName,
                        show: false
                    }
                }))}
            />

            <SupplierSelectorDrawer
                stateShow={data.filterStockSupplier.show}

                fnShow={() => setData(d => ({
                    ...d,
                    filterStockSupplier: {
                        ...d.filterStockSupplier,
                        show: false
                    }
                }))}

                stateData={{
                    supplierIsActive: '1'
                }}

                fnOnSelect={(object) => setData(d => ({
                    ...d,
                    filterStockSupplier: {
                        ...d.filterStockSupplier,
                        id: object.supplierId,
                        name: object.supplierName,
                        address: object.supplierAddress,
                        contact: object.supplierContact,
                        isActive: object.supplierIsActive,
                        show: false
                    }
                }))}
            />
        </React.Fragment>
    )
}

export default StockItemFilter;